/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from "react";
import { Alert, Button, Spin, PageHeader, Layout, Space,Result,Image } from "antd";
import { Formik } from "formik";
import { onecodeAPI } from "../AppConfig";
import { createYupSchema } from "./yupSchemaCreator";
import { useCookies } from 'react-cookie';
import _ from "lodash";
import * as Yup from "yup";
import uuid from 'react-uuid';
import TextInput from "./TextInput";
import { Redirect } from "react-router";
import { useNavigate } from "react-router-dom";
// import "antd/es/spin/style/css";

export default function () {
  const [formData, setFormData] = useState([]);
  const [partnerId, setPartnerId] = useState("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const { Header, Content, Footer } = Layout;
  const [message, setMessage] = useState("");
  const [cookies, setCookie] = useCookies(['partnerId']);
  const [ocDeviceId, setOcuuid] = useState(uuid())
  const [categoryId,setCategoryId] =useState("");
  const [customerData,setCustomerData]=useState({})
  let navigate = useNavigate();

  let params = new URLSearchParams(window.location.search);

  let hash = params.get("hash");
  let pathName =  window.location.pathname;
  useEffect(() => {
    getFormData();
  }, []);

  let urlencode =  encodeURIComponent(hash)
  const getFormData = async () => {
    setLoading(true);
    let getFormData = [];
    let response;
    try {
         response = await onecodeAPI.post(`/partnerForm/findByPartner/v4`,{hash:urlencode});

         setCustomerData(response.data.data);
      
      if (_.has(response.data, "message") && _.has(response.data, "partnerId")) {
          let message = _.get(response,"data.message");
          let partnerId = _.get(response,"data.partnerId");
          let partnerCategoryId = _.get(response,"data.partnerCategoryId");
        setMessage(message);
        setPartnerId(partnerId);
        setCategoryId(partnerCategoryId);
      }

      getFormData = _.get(response,"data.data.partnerForms");
      let partnerId = _.get(response,"data.data.partnerForms[0].partnerId")
      setPartnerId(partnerId);
      let partnerCategoryId = _.get(response,"data.data.partnerForms[0].partnerCategoryId")
      setCategoryId(partnerCategoryId);
      let description = _.get(response,"data.data.partnerForms[0].partner.description")
      setDesc(description)
      setFormData(getFormData);
      setLoading(false)
      if(cookies["oc-deviceId"] == undefined) {
          setCookie('oc-deviceId', ocDeviceId, { path: '/' });
      }   

      if (_.has(response.data, "data")) {
        getFormData = _.get(response,"data.data.partnerForms");
        let partnerId = _.get(response,"data.data.partnerForms[0].partnerId")
      setPartnerId(partnerId);
      let partnerCategoryId = _.get(response,"data.data.partnerForms[0].partnerCategoryId")
      setCategoryId(partnerCategoryId);
        let description = _.get(
          response,
          "data.data.partnerForms[0].partner.description"
        );
        setDesc(description);
        setFormData(getFormData);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const initialValues = {};
  formData.length &&
    formData[0].ocForm.ocFieldGroups.forEach((page) => {
      page.ocFields.forEach((item) => {
         if (item.code === "name") {
           initialValues[item.id] = customerData.customerName ? customerData.customerName : "";
         } else if (item.code === "phnNo") {
           initialValues[item.id] = customerData.customerPhoneNumber ? customerData.customerPhoneNumber : "";
         } else {
          initialValues[item.id] = ""
        }
      });
    });

  let ocFields = [];
  formData.length &&
    formData[0].ocForm.ocFieldGroups.map((page) => {
      ocFields = ocFields.concat(page.ocFields);
    });

  const yepSchema = ocFields.reduce(createYupSchema, {});
  const validationSchema = Yup.object().shape(yepSchema);

     const  onSubmit  = async (values,error) =>{
        setLoading(true)
        // console.log('clicked onSubmit');
        let fieldValues = [];
    
        _.map( values,(value,key) => { 
           
            let fieldValue = {
                ocFieldId : key,
                value : value
            }
            fieldValues.push(fieldValue);
         } )
    
        let data = {
            ocPartnerFormId : formData[0].id,
            ocFieldValues : fieldValues,
            deviceId: cookies["oc-deviceId"] || ocDeviceId,
            partnerCategoryId:categoryId
        }
        let v2Data  = {
          ocUserForm :{ 
            ocPartnerFormId : formData[0].id,
            ocFieldValues : fieldValues
          },
            deviceId: cookies["oc-deviceId"] || ocDeviceId,
            partnerCategoryId:categoryId,
            hash:urlencode,
            hasOtpCheck:false
        }
        let res;
        try{

             res = await onecodeAPI.post(`/userForm/addLead/v2`,v2Data);

            let brandUrl = res.data.data.url;
            let leadID = _.get(res,"data.data.userForm.id")
            let rcdetails = _.get(res,"data.data.RcDetail")
            let motorDetails = {
                rcdetails:rcdetails,
                brandUrl:brandUrl
            }
            
            if(brandUrl && !brandUrl.includes("null") && rcdetails){
                navigate(`/rcv/step2`,{
                    state: motorDetails,
                });
            }

            setLoading(false)
        }catch(err){
            console.log(err,"err");
          let message = _.get(err,"response.data.message","Something went wrong----")
          let splitErrors = message.split(",");
          
          let errors = {}
          splitErrors.forEach( id => {
            errors = {...errors,[id]:"Details already exist"}
          } )
          
          error.setErrors(errors)
          setLoading(false)
          alert(message);
        }
    
      }

      const FormData = (formProperties) => {
        let form = [];
        formData.length &&
          formData[0].ocForm.ocFieldGroups.map((page, pageIndex) => {
         return   page.ocFields.map((e, index) =>  {
            if (e.type === "text") {
                form.push(<TextInput {...e} key={index} {...formProperties} disableInput = { customerData?.customerPhoneNumber ? true : false } />);
              }
            });
          });
        return form;
      };
 

  if (message) {
    return (
      <div style={{ height: "100%" }}>
        {partnerId ? (
          <div
            style={{
              height: "20%",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              display: "flex",
              marginTop: 10,
            }}
          >
            <img
              src={ categoryId ? `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}_${categoryId}.jpg` : `https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerId}.jpg`}
              style={{ width: "50%", alignItems: "center" }}
            />
          </div>
        ) : (
          <></>
        )}

        <div
          style={{
            height: "80%",
            // marginTop: "50%",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            // alignItems: "center",
            fontSize: "25px",
            paddingTop: partnerId ? "100px" : "300px",
          }}
        >
          {message}
        </div>
      </div>
    );
  } else {

    return (
      <Layout className="layout" style={{backgroundColor:"#ffff"}}  >
        <PageHeader
            className="site-page-header"
            title="2 Wheeler insurance"
            style = {{background : "#6c63ff",height:60,paddingTop:10,textAlign : "center"}}
        />
        <Content>
        {cookies.partnerLeadSubmissionCount && Number(cookies.partnerLeadSubmissionCount)+1 > 5 ? <Alert message="You cannot access this page!" type="error" /> :         
          <Spin
            spinning={loading}
            style={{
              flex: 1,
              alignContent: "center",
              justifyContent: "center",
            }}
          >
              <div style = {{marginLeft: 20,marginRight : 20}}>
              <div style = {{marginTop : 10}}>
                  <p>Please fill the following details to generate insurance quote for your 2 wheeler</p>
              </div>
            </div>
            {
                formData != null && formData.length > 0 ? 
            
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              validateOnBlur={true}
              validateOnChange={true}
              enableReinitialize
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                isValid,
                touched,
                setValues,
                setTouched,
                resetForm,
              }) => (
                <div style={{ marginTop: 20, textAlign: "center" }}>
                  <FormData
                    handleChange={handleChange}
                    values={values}
                    handleBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                    setValues={setValues}
                    setTouched={setTouched}
                  />
                  <div style={{ textAlign: "center" }}>
                    <Button
                      style={{
                        minWidth: 250,
                        padding: 8,
                        borderRadius: 5,
                        height: 40,
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        marginTop: 20,
                        borderColor: "#6c63ff",
                        borderWidth: 1,
                      }}
                      onClick={handleSubmit}
                    >
                      Save & Proceed
                    </Button>
                  </div>
                </div>
               
               )}
                        </Formik>:<Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
            />}
            </Spin>
            }
        </Content>
      </Layout>
    );
  }
}